/**
 * Scale/perf tuning for large Trackers boards.
 *
 * The board keeps the full working set in memory for client-side grouping /
 * sort / filter / dashboard aggregation (monday.com's hybrid-client model), so
 * we bound how much we load and render:
 *  - `BOARD_ROW_CAP`        — max rows loaded into memory per board; past it the
 *                             UI shows a "showing first N — refine filters" note.
 *  - `ITEMS_PAGE_SIZE`      — chunk size for the accumulating paged fetch.
 *  - `VIRTUALIZE_THRESHOLD` — a group's rows are windowed only once it exceeds
 *                             this; smaller groups render as-is (no dnd/scroll
 *                             change).
 *
 * Lives in `shared` so both `entities/*` (data fetching) and `widgets/*`
 * (rendering) can import it without crossing FSD layers.
 */
export const BOARD_ROW_CAP = 1500;
export const ITEMS_PAGE_SIZE = 200;
export const VIRTUALIZE_THRESHOLD = 80;
